<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    remote
    :remote-method="requestData"
    :loading="loading"
    @change="handleChange"
    placeholder="搜索并选择，可多选"
    style="width: 100%"
    multiple
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { itemCategoryList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value.length > 0) {
      this.requestData('', this.value)
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query = '', defaultVal = []) {
      let data = {
        query: query,
        category: this.category,
        page: 0,
        size: 20,
        is_select_option: true,
      }

      if (defaultVal.length > 0) {
        data.item_category_ids = `${defaultVal.join('&item_category_ids=')}`
      }

      if (query.length > 0 || defaultVal.length > 0) {
        this.loading = true
        let res = await itemCategoryList(data)
        this.loading = false
        this.lists = res.data.list.map((item) => {
          if (item.whole_name) {
            item.name = item.whole_name.replace(/,/g, ' - ')
          }
          return item
        })
      } else {
        // this.lists = []
      }
    },
  },
}
</script>